import React from "react";
import { useFormikContext } from "formik";
import CaretDown24 from "../../../../assets/svg/icons/common/CaretDown24";
import CheckGreenCircleIcon from "../../../../assets/svg/icons/common/check-green-circle";
import FancyRadioInput from "../../../../components/form/fancy-radio-input";
import SlidingToggle from "../../../../components/form/sliding-checkbox";
import TimeInput from "../../../../components/form/time-input";
import TextInput from "../../../../components/form/text-input";
import useUserStore from "../../../../stores/user";
import styles from "./style.module.scss";

import { detailsInfoSchema } from "../../validation-schema";
import baseStyles from "../../style.module.scss";
const Details = ({ detailsInfoField, isOpen, onToggle }) => {
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } = useFormikContext();
  const isSectionValid = detailsInfoSchema.isValidSync(values);
  const userOrgIsEMS = useUserStore((state) => state.userOrgIsEMS);

  if (!isOpen) {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <div
            onClick={onToggle}
            className={`${styles.header_left} ${baseStyles.headerLeft} ${isOpen && baseStyles.headerLeftOpen}`}
          >
            <CaretDown24 />
            <h6 className={styles.title}>Details</h6>
          </div>
          <div className={baseStyles.headerRight} style={{ display: "flex" }}>
            {isSectionValid && <CheckGreenCircleIcon />}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div
          onClick={onToggle}
          className={`${styles.header_left} ${baseStyles.headerLeft} ${isOpen && baseStyles.headerLeftOpen}`}
        >
          <CaretDown24 />

          <h6 className={styles.title}>Details</h6>
        </div>
        <div className={baseStyles.headerRight}>
          {isSectionValid && <CheckGreenCircleIcon />}
        </div>
      </div>

      {isOpen && (
        <div className={styles.content}>
          <div className={`${styles.grid} ${styles.gridCol2} ${styles.gap24}`}>
            <div className={styles.radioItem}>
              <p className={styles.p_heading}>Who deploys equipment</p>
              <div className={styles.radiosGrid2}>
                <FancyRadioInput
                  label={"Agent"}
                  id={"agent"}
                  name={"who_to_deploy_equipment"}
                  value={"agent"}
                  checked={values.who_to_deploy_equipment === "agent"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={styles.customRadio}
                />
                <FancyRadioInput
                  label={"Processor"}
                  id={"processor"}
                  name={"who_to_deploy_equipment"}
                  value={"processor"}
                  checked={values.who_to_deploy_equipment === "processor"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={styles.customRadio}
                />
              </div>
              {errors.who_to_deploy_equipment &&
                touched.who_to_deploy_equipment && (
                  <p className={styles.error}>
                    {errors.who_to_deploy_equipment}
                  </p>
                )}
            </div>
            <div className={styles.radioItem}>
              <p className={styles.p_heading}>Who pays for equipment</p>
              <div className={styles.radiosGrid2}>
                <FancyRadioInput
                  label={"Agent"}
                  id={"who_to_pay_for_equipment_1"}
                  name={"who_to_pay_for_equipment"}
                  value={"agent"}
                  checked={values.who_to_pay_for_equipment === "agent"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={styles.customRadio}
                />
                <FancyRadioInput
                  label={"Merchant"}
                  id={"who_to_pay_for_equipment_2"}
                  name={"who_to_pay_for_equipment"}
                  value={"merchant"}
                  checked={values.who_to_pay_for_equipment === "merchant"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={styles.customRadio}
                />
              </div>
              {errors.who_to_pay_for_equipment &&
                touched.who_to_pay_for_equipment && (
                  <p className={styles.error}>
                    {errors.who_to_pay_for_equipment}
                  </p>
                )}
            </div>
            <div className={styles.radioItem}>
              <p className={styles.p_heading}>Who deploys gateway</p>
              <div className={styles.radiosGrid2}>
                <FancyRadioInput
                  label={"Agent"}
                  id={"who_to_deploy_gateway_1"}
                  name={"who_to_deploy_gateway"}
                  value={"agent"}
                  checked={values.who_to_deploy_gateway === "agent"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={styles.customRadio}
                />
                <FancyRadioInput
                  label={"Processor"}
                  id={"who_to_deploy_gateway_2"}
                  name={"who_to_deploy_gateway"}
                  value={"processor"}
                  checked={values.who_to_deploy_gateway === "processor"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={styles.customRadio}
                />
              </div>
              {errors.who_to_deploy_gateway &&
                touched.who_to_deploy_gateway && (
                  <p className={styles.error}>{errors.who_to_deploy_gateway}</p>
                )}
            </div>
            <div className={styles.radioItem}>
              <p className={styles.p_heading}>Preferred billing sequence</p>
              <div className={styles.radiosGrid2}>
                <FancyRadioInput
                  label={"Daily"}
                  id={"Daily"}
                  name={"billing_sequence"}
                  value={"daily"}
                  checked={values.billing_sequence === "daily"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={styles.customRadio}
                />
                <FancyRadioInput
                  label={"Weekly"}
                  id={"Weekly"}
                  name={"billing_sequence"}
                  value={"weekly"}
                  checked={values.billing_sequence === "weekly"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={styles.customRadio}
                />
              </div>
              {errors.billing_sequence && touched.billing_sequence && (
                <p className={styles.error}>{errors.billing_sequence}</p>
              )}
            </div>

            {userOrgIsEMS && (
              <>
                <div className={styles.radioItem}>
                  <p className={styles.p_heading}>
                    Cover cancellation fees they&apos;ll incur by switching?
                  </p>
                  <div className={styles.radios}>
                    <SlidingToggle
                      options={["yes", "no"]}
                      width="150px"
                      value={values.cover_cancellation}
                      onChange={(values) => {
                        handleChange({
                          target: {
                            name: "cover_cancellation",
                            value: values,
                          },
                        });

                        if (values === "no") {
                          setFieldValue("reimbursement_maximum", "");
                        }
                      }}
                    />
                  </div>
                </div>

                <div>
                  {values.cover_cancellation === "yes" && (
                    <TextInput
                      type="text"
                      label="Reimbursement maximum"
                      name="reimbursement_maximum"
                      placeholder="300"
                      prefix="$"
                      value={values.reimbursement_maximum}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      cleaveOptions={{
                        numeral: true,
                        decimalScale: 2,
                        numeralDecimalMark: ".",
                        min: 0,
                        onValueChanged: (e) => {
                          handleChange({
                            ...e,
                            target: {
                              ...e.target,
                              value: e.target.rawValue,
                            },
                          });
                        },
                      }}
                      errored={errors.reimbursement_maximum}
                      error={errors.reimbursement_maximum}
                      touched={touched.reimbursement_maximum}
                    />
                  )}
                </div>
              </>
            )}

            <div className={styles.radioItem}>
              <p className={styles.p_heading}>
                Opt merchant into expedited funding?
              </p>
              <div className={styles.radios}>
                <SlidingToggle
                  options={["yes", "no"]}
                  width="150px"
                  value={values.expedited_funding}
                  onChange={(values) =>
                    handleChange({
                      target: { name: "expedited_funding", value: values },
                    })
                  }
                />
              </div>
              {errors.expedited_funding && touched.expedited_funding && (
                <p className={styles.error}>{errors.expedited_funding}</p>
              )}
            </div>
            <div className={styles.radioItem}>
              <TimeInput
                label={"Desired auto batch time"}
                name={"batch_time"}
                value={values.batch_time}
                onChange={(value) => {
                  console.log("batch_time", value);
                  handleChange({
                    target: {
                      name: "batch_time",
                      value: value,
                    },
                  });
                }}
                error={
                  errors.batch_time && touched.batch_time && errors.batch_time
                }
              />
            </div>
          </div>

          <div className={styles.radioItem}>
            <p className={styles.p_heading}>Ship equipment to</p>
            <div className={styles.radiosGrid4}>
              <FancyRadioInput
                label={"Legal address"}
                id={"equipment_address_1"}
                name={"equipment_address"}
                value={"legal_address"}
                checked={values.equipment_address === "legal_address"}
                onChange={handleChange}
                onBlur={handleBlur}
                className={styles.customRadio}
              />
              <FancyRadioInput
                label={"Home Address"}
                id={"equipment_address_2"}
                name={"equipment_address"}
                value={"home_address"}
                checked={values.equipment_address === "home_address"}
                onChange={handleChange}
                onBlur={handleBlur}
                className={styles.customRadio}
              />
              <FancyRadioInput
                label={"DBA Address"}
                id={"equipment_address_3"}
                name={"equipment_address"}
                value={"dba_address"}
                checked={values.equipment_address === "dba_address"}
                onChange={handleChange}
                onBlur={handleBlur}
                className={styles.customRadio}
              />
              <FancyRadioInput
                label={"Agent Address"}
                id={"equipment_address_4"}
                name={"equipment_address"}
                value={"agent_address"}
                checked={values.equipment_address === "agent_address"}
                onChange={handleChange}
                onBlur={handleBlur}
                className={styles.customRadio}
              />
            </div>
            {errors.equipment_address && touched.equipment_address && (
              <p className={styles.error}>{errors.equipment_address}</p>
            )}
          </div>

          <div className={styles.radioItem}>
            <p className={styles.p_heading}>Send invoice to</p>
            <div className={styles.radiosGrid4}>
              <FancyRadioInput
                label={"Legal address"}
                id={"invoice_address_1"}
                name={"invoice_address"}
                value={"legal_address"}
                checked={values.invoice_address === "legal_address"}
                onChange={handleChange}
                onBlur={handleBlur}
                className={styles.customRadio}
              />
              <FancyRadioInput
                label={"Home Address"}
                id={"invoice_address_2"}
                name={"invoice_address"}
                value={"home_address"}
                checked={values.invoice_address === "home_address"}
                onChange={handleChange}
                onBlur={handleBlur}
                className={styles.customRadio}
              />
              <FancyRadioInput
                label={"DBA Address"}
                id={"invoice_address_3"}
                name={"invoice_address"}
                value={"dba_address"}
                checked={values.invoice_address === "dba_address"}
                onChange={handleChange}
                onBlur={handleBlur}
                className={styles.customRadio}
              />
              <FancyRadioInput
                label={"Agent Address"}
                id={"invoice_address_4"}
                name={"invoice_address"}
                value={"agent_address"}
                checked={values.invoice_address === "agent_address"}
                onChange={handleChange}
                onBlur={handleBlur}
                className={styles.customRadio}
              />
            </div>
            {errors.invoice_address && touched.invoice_address && (
              <p className={styles.error}>{errors.invoice_address}</p>
            )}
          </div>

          <div className={styles.specialInstructions}>
            <p className={styles.p_heading}>
              Special Instructions <span>(optional)</span>
            </p>
            <textarea
              className={styles.textarea}
              name="special_instructions"
              id="special_instructions"
              placeholder="Special Instructions"
              value={values.special_instructions}
              onChange={handleChange}
            ></textarea>
            {errors.special_instructions && (
              <p className={styles.error}>{errors.special_instructions}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Details;
